<kodit-page>
  <div *ngIf="showImportSection">
    <div class="import-section p-mb-3" >
      <p-fileUpload
        [customUpload]="customUpload"
        (uploadHandler)="otpremiDatoteku($event)"
        [multiple]="importMultiple"
      >
      <ng-template pTemplate="toolbar">
        <button
          pButton
          type="button"
          icon="fa-solid fa-x"
          class="close-button"
          (click)="close()"
        ></button>
        <div class="p-mt-3">
          <p-progressBar
            *ngIf="showProgressBar"
            mode="indeterminate"
            [style]="{ height: '6px' }"
          ></p-progressBar>
        </div>
      </ng-template>
        <ng-template let-file pTemplate="file">
          <div class="file-container">
            <div class="container-left">
              <i class="fa-solid fa-file-lines file-icon"></i>
              <div>
                <div class="file-name">{{ file.name }}</div>
                <div class="file-size">{{ file.size }} kb</div>
              </div>
            </div>
            <div>
              <kodit-grupe-kategorija-dropdown></kodit-grupe-kategorija-dropdown>
            </div>
          </div>
        </ng-template>
      </p-fileUpload>
    </div>
  </div>
  <kodit-table [tableConfig]="tableConfig" [paginatedData]="paginatedData" [isTableLoading]="isLoading"></kodit-table>
</kodit-page>
